(function(){
'use strict';

CFPExistingPageViewFactory.$inject = ["scFlowModalService"];
function CFPExistingPageViewFactory(scFlowModalService) {
  return function CFPExistingPageView(parentScope) {
    var $scope = parentScope.$new();

    $scope.done = function () {
      scFlowModalService.close();
    };

    /* ---------------------------------------------------------------------- *
     * View object
     * ---------------------------------------------------------------------- */

    return {
      id: 'indiv.existing-page',
      templateUrl: $scope.flow.template('existing-page'),
      maxWidth: 385,
      context: $scope
    };
  };
}

angular.module('classy').factory('CFPExistingPageView', CFPExistingPageViewFactory);
})();